import instance from "../config";

// Productos habilitados para alquiler (con precioAlquilerDia configurado y stock)
const getProductosAlquilables = async () => {
  try {
    const response = await instance.get("/api/alquiler/productos-disponibles");
    return response.data;
  } catch (error) {
    console.error(error);
    return { success: false, data: [] };
  }
};

// Crear un alquiler nuevo
const crearAlquiler = async (data) => {
  try {
    const response = await instance.post("/api/alquiler", data);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Listar alquileres (con filtros opcionales)
const getAlquileres = async (params) => {
  try {
    const response = await instance.get("/api/alquiler", { params });
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Obtener el detalle de un alquiler
const getUnAlquiler = async (id) => {
  try {
    const response = await instance.get(`/api/alquiler/${id}`);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Editar los datos generales del alquiler (cliente, fechas, observaciones)
const editarAlquiler = async (id, data) => {
  try {
    const response = await instance.patch(`/api/alquiler/${id}`, data);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Corregir la cantidad originalmente registrada en una línea (solo admin)
const editarCantidadAlquilerDetalle = async (detalleId, cantidad) => {
  try {
    const response = await instance.patch(`/api/alquiler/detalle/${detalleId}`, { cantidad });
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Registrar la devolución (total o parcial) de una línea del alquiler
const registrarDevolucionAlquiler = async (alquilerDetalleId, data) => {
  try {
    const response = await instance.patch(
      `/api/alquiler/devolucion/${alquilerDetalleId}`,
      data,
    );
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Eliminar un registro del historial de devoluciones (revierte inventario,
// montos y el estado del alquiler si corresponde)
const eliminarDevolucion = async (devolucionId) => {
  try {
    const response = await instance.delete(`/api/alquiler/devolucion/${devolucionId}`);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Cancelar/eliminar un alquiler (solo si no tiene devoluciones registradas)
const eliminarAlquiler = async (id) => {
  try {
    const response = await instance.delete(`/api/alquiler/${id}`);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Aplica un pago al total_pagado del alquiler (valida contra la deuda
// pendiente). Se usa ANTES de postAbonoAlquiler, igual que en venta rápida
// (obtenerAbonos -> postAbonoVR).
const aplicarAbonoAlquiler = async (id, monto) => {
  try {
    const response = await instance.patch(`/api/alquiler/aplicar-abono/${id}`, { monto });
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Registrar un abono de un alquiler (historial/auditoría; el abono inicial
// ya se guarda directo en Alquiler.total_pagado al crear el alquiler)
const postAbonoAlquiler = async (alquilerId, monto, descripcion, id_user, fecha_abono, hora_abono) => {
  try {
    const response = await instance.post("/api/alquiler-abono", {
      alquilerId,
      monto,
      descripcion,
      id_user,
      fecha_abono,
      hora_abono,
    });
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Editar un abono ya registrado (monto, descripción, fecha, hora)
const editarAbonoAlquiler = async (id, data) => {
  try {
    const response = await instance.put(`/api/alquiler-abono/${id}`, data);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Listar los abonos registrados de un alquiler
const getAbonosAlquiler = async (alquilerId) => {
  try {
    const response = await instance.get(`/api/alquiler-abono/${alquilerId}`);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Eliminar un abono (revierte el total_pagado del alquiler)
const eliminarAbonoAlquiler = async (id) => {
  try {
    const response = await instance.delete(`/api/alquiler-abono/${id}`);
    return { status: response.status, res: response.data };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

export {
  getProductosAlquilables,
  crearAlquiler,
  getAlquileres,
  getUnAlquiler,
  editarAlquiler,
  registrarDevolucionAlquiler,
  editarCantidadAlquilerDetalle,
  eliminarDevolucion,
  eliminarAlquiler,
  aplicarAbonoAlquiler,
  postAbonoAlquiler,
  editarAbonoAlquiler,
  getAbonosAlquiler,
  eliminarAbonoAlquiler,
};
